import { Injectable } from '@angular/core';

@Injectable( {
  providedIn: 'root'
} )
export class LocalStorageService
{

  public get<T = any>( key: string ): T | null
  {
    const value = localStorage.getItem( key );
    try
    {
      return value ? JSON.parse( value ) as T : null;
    } catch {
      return null;
    }
  }

  public set<T = any>( key: string, value: T ): void
  {
    localStorage.setItem( key, JSON.stringify( value ) );
  }

  public delete( key: string ): void
  {
    localStorage.removeItem( key );
  }

  public clear(): void
  {
    localStorage.clear();
  }

  public has( key: string ): boolean
  {
    return localStorage.getItem( key ) !== null;
  }

  public keys(): string[]
  {
    return Object.keys( localStorage );
  }

}
